import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/transport",
    name: "Transport",
    meta: {
      title: "运输单列表",
    },
    component: () => import('../views/transport/index.vue')
  },
  {
    path: "/loading",
    name: "Loading",
    meta: {
      title: "运输单列表",
    },
    component: () => import('../views/loading/index.vue')
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  //过滤登录页面
  if(to.fullPath == '/'){
    return true;
  }
  // 从sessionStorage中获取token,权限菜单url，
  const token = sessionStorage.getItem("UAP_accessToken");
  const rToken = sessionStorage.getItem("UAP_refreshToken");
  const menuUrlsArr = sessionStorage.getItem("menuUrls")?.split(',');
  if (!token || !rToken || !menuUrlsArr?.includes(to.fullPath)) {
   //向UAP发送消息，跳转到登录页面
    window.parent.postMessage('toLogin', process.env.VUE_APP_UAP_SERVER_PATH);
  }
  
})

router.onError((error) => {
  console.log(error, "路由错误");
});



export default router



